module.exports = __webpack_public_path__ + "img/hr-car-5.4a175f9e.png";